import { render, staticRenderFns } from "./SearchAnswers.vue?vue&type=template&id=ccf3e6f0"
import script from "./SearchAnswers.vue?vue&type=script&lang=js"
export * from "./SearchAnswers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports